document.addEventListener('DOMContentLoaded', () => {
  var totalOffers = document.querySelectorAll('.swiper-slide.co-card').length;
  var swiperPagination = document.querySelector("div.swiper-pagination.co-pagination");
  const currentOfferSwiper = new Swiper('.co-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    slidesPerView: 3,
    spaceBetween: 10,
    pagination: {
      el: swiperPagination,
        clickable: true,
    },
    navigation: {
      nextEl: '.co-next',
      prevEl: '.co-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      500: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      1000: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      1300: {
        slidesPerView: 4,
        slidesPerGroup: 1,
      },
      1600: {
        slidesPerView: 5,
        slidesPerGroup: 1,
      }
    },
  });
});

// Get the modal
var offersSection = document.querySelector(".current-offer-pop");
var currentOffer_Backdrop = document.getElementById("offer-pop-brackdrop");
var currentOffer_List = document.getElementById("offer-pop-content");

// Get the button that opens the modal
var currentOffer_Button = document.getElementById("currentOffer-btn");

// Get offer detail
var currentOffer_DetailLink = document.getElementById("co-item-link-1");
var currentOffer_Detail = document.getElementById("offer-details-1");

// Get the <span> element that closes the modal
  var closeButton = document.querySelector('svg.icon-close-small') || document.querySelector('.popup-close-hidden');

function displayCurrentOffers(){
  offersSection.classList.add("open");
  currentOffer_List.classList.remove("toa-hidden");
  currentOffer_List.classList.add("toa-visible");
  setTimeout(() => {
    currentOffer_Button.classList.add("open");
  }, 100);
}
function hideCurrentOffers(){
    offersSection.classList.remove("open")
    currentOffer_Button.style.bottom = '95px';
    currentOffer_List.classList.remove("toa-visible");
    currentOffer_List.classList.add("toa-hidden");
    setTimeout(() => {
          currentOffer_Button.classList.remove("open");
        }, 100);
}


var coItemLinks = document.querySelectorAll('.co-item-link');
var toaCloses = document.querySelectorAll('.toa-close > svg');
var offCardDetail = document.querySelectorAll('.offer_card_details');



// Add click event listener to each element
coItemLinks.forEach(function(element) {
  element.addEventListener('click', function() {
    var parentOfferCard = this.closest('.offer_card');
    // Find the 'offer-details' within the parent 'offer_card' element
    var coItemLinkWithinParent = parentOfferCard.querySelector('.offer-details');
    
    if (element.classList.contains('active')) {
      // Element is active, hide details and remove active class
      coItemLinkWithinParent.classList.remove('toa-visible');
      coItemLinkWithinParent.classList.add('toa-hidden');
      
      // Remove 'active' class from the currently active link
      var activeLink = parentOfferCard.querySelector('.co-item-link.active');
      if (activeLink) {
        activeLink.classList.remove('active');
      }
    } else {
      // Element is not active, show details and set as active
      coItemLinkWithinParent.classList.remove('toa-hidden');
      coItemLinkWithinParent.classList.add('toa-visible');
      parentOfferCard.querySelector('.toa_content > p').style.display = "block";
      element.classList.add('active');
    }
  });
});


offCardDetail.forEach(function(detailElement) {
  detailElement.addEventListener('click', function(event) {
    // Check if the click event is coming from '.co-item-link' or its descendants
    var coItemLink = event.target.closest('.co-item-link');
    
    if (!coItemLink) {
      // Handle the click event only if it did not originate from a '.co-item-link'
      let parentOfferCard = this.closest('.offer_card');
      if (parentOfferCard) {
        var coItemLinkWithinParent = parentOfferCard.querySelector('.offer-details');

        if (coItemLinkWithinParent.classList.contains('toa-visible')) {
          coItemLinkWithinParent.classList.remove('toa-visible');
          coItemLinkWithinParent.classList.add('toa-hidden');

          // Also, remove 'active' class from any currently active link
          var activeLink = parentOfferCard.querySelector('.co-item-link.active');
          if (activeLink) {
            activeLink.classList.remove('active');
          }
        } 
      }
    }
  });
});


toaCloses.forEach(function(closeBtn) {
  closeBtn.addEventListener('click', function() {
    var parentOfferCard = this.closest('.offer_card'); // Find the closest parent .offer_card element
    if (parentOfferCard) {
      var coItemLinkWithinParent = parentOfferCard.querySelector('.offer-details');
      if (coItemLinkWithinParent) {
        coItemLinkWithinParent.classList.remove('toa-visible');
        coItemLinkWithinParent.classList.add('toa-hidden');
      }
      var activeLink = parentOfferCard.querySelector('.co-item-link.active');
      if (activeLink) {
        activeLink.classList.remove('active'); // Remove 'active' class from the related .co-item-link
      }
    }
  });
});
// When the user clicks the button, open the modal 
currentOffer_Button.onclick = function() {
  this.style.bottom = '380px';
  displayCurrentOffers();
}


// When the user clicks anywhere outside of the modal or button, close it
document.addEventListener('click', function (event) {
  if (event.target == currentOffer_Backdrop) {
    hideCurrentOffers();
  }
  if (event.target.closest('.popup-close-hidden')) {
    hideCurrentOffers(); 
  }

  if (event.target == currentOffer_Button && currentOffer_Button.classList.contains('open') ) {
    hideCurrentOffers();
  }

  if (event.target == currentOffer_Button && currentOffer_Button.classList.contains('open') ) {
    hideCurrentOffers();
  }

  var parentOfferCards = document.querySelectorAll('.offer_card');
  var coItemLinks = document.querySelectorAll('.co-item-link');

  // Check if coItemLinks contain 'active' class
  var isActive = Array.from(coItemLinks).some(function(link) {
    return link.classList.contains('active');
  });

  // Check if click target is not part of any parentOfferCard and coItemLinks contains 'active'
  if (!isClickedInsideParent(event.target, parentOfferCards) && isActive) {
    // Perform actions for each parentOfferCard
    parentOfferCards.forEach(function(parentOfferCard) {
      var coItemLinkWithinParent = parentOfferCard.querySelector('.offer-details');
      if (coItemLinkWithinParent) {
        coItemLinkWithinParent.classList.remove("toa-visible");
        coItemLinkWithinParent.classList.add('toa-hidden');
      }
    });

    // Remove 'active' class from all coItemLinks
    coItemLinks.forEach(function(link) {
      link.classList.remove('active');
    });
  }

});

function isClickedInsideParent(target, parents, isActive) {
  for (var i = 0; i < parents.length; i++) {
    if (parents[i].contains(target)) {
      return true;
    }
  }
  return false;
}

//Hide Button Current Offer in Footer
window.addEventListener('scroll',function(){
  let footer = document.querySelector('footer');
  let footerTop = footer.getBoundingClientRect().top;

  let currentOfferBotton = currentOffer_Button.getBoundingClientRect().bottom;

  if(currentOfferBotton >= footerTop){
    currentOffer_Button.classList.add('display_co_btn');
  }else{
    currentOffer_Button.classList.remove('display_co_btn');
  }
})